module.exports = __webpack_public_path__ + "static/swica-8b68fb7baf90dec0f1d143ccafafbbcc.png";